"use strict";

var pageRelationsPromise = function pageRelationsPromise() {
    return new Promise(function (t, a) {
      localforage.getItem("pageRelations").then(function (e) {
        null === e ? $.ajax({
          url: base_path + "/JSONFiles/pageRelation.json",
          dataType: "json",
          cache: !0,
          success: function success(e) {
            localforage.setItem("pageRelations", e).then(function (e) {
              t(e);
            })["catch"](function (e) {
              a(e);
            });
          },
          error: function error(e, t, n) {
            a("error");
          },
          complete: function complete() {}
        }) : t(e);
      })["catch"](function (e) {
        a(e);
      });
    });
  },
  getSurahNamesPromise = (pageRelationsPromise(), function () {
    return new Promise(function (t, a) {
      localforage.getItem("surahNames").then(function (e) {
        null === e ? $.ajax({
          url: base_path + "/JSONFiles/surahNames.json",
          dataType: "json",
          cache: !0,
          success: function success(e) {
            localforage.setItem("surahNames", e).then(function (e) {
              t(e);
            })["catch"](function (e) {
              a(e);
            });
          },
          error: function error(e, t, n) {
            a("error");
          },
          complete: function complete() {}
        }) : t(e);
      })["catch"](function (e) {
        a(e);
      });
    });
  }),
  getSurahNameImages_IndoPakPromise = (getSurahNamesPromise(), function () {
    return new Promise(function (t, a) {
      localforage.getItem("surahNameImages_IndoPak").then(function (e) {
        null === e ? $.ajax({
          url: base_path + "/JSONFiles/surahNameImages_IndoPak.json",
          dataType: "json",
          cache: !0,
          success: function success(e) {
            localforage.setItem("surahNameImages_IndoPak", e).then(function (e) {
              t(e);
            })["catch"](function (e) {
              a(e);
            });
          },
          error: function error(e, t, n) {
            a("error");
          },
          complete: function complete() {}
        }) : t(e);
      })["catch"](function (e) {
        a(e);
      });
    });
  }),
  getTotalAyaatPromise = (getSurahNameImages_IndoPakPromise(), function () {
    return new Promise(function (t, a) {
      localforage.getItem("getTotalAyaatPromise").then(function (e) {
        null === e ? $.ajax({
          url: base_path + "/JSONFiles/totalAyaat.json",
          dataType: "json",
          cache: !0,
          success: function success(e) {
            localforage.setItem("getTotalAyaatPromise", e).then(function (e) {
              t(e);
            })["catch"](function (e) {
              a(e);
            });
          },
          error: function error(e, t, n) {
            a("error");
          },
          complete: function complete() {}
        }) : t(e);
      })["catch"](function (e) {
        a(e);
      });
    });
  }),
  getTotalAyaatPromise2 = function getTotalAyaatPromise2() {
    return new Promise(function (t, a) {
      $.ajax({
        url: base_path + "/JSONFiles/totalAyaat.json",
        dataType: "json",
        cache: !0,
        success: function success(e) {
          t(e);
        },
        error: function error(e, t, n) {
          a(n);
        },
        complete: function complete() {}
      });
    });
  },
  paraRelationsPromise = (getTotalAyaatPromise(), function () {
    return new Promise(function (t, a) {
      localforage.getItem("paraRelations").then(function (e) {
        null === e ? $.ajax({
          url: base_path + "/JSONFiles/paraRelationWithAyat.json",
          dataType: "json",
          cache: !0,
          success: function success(e) {
            localforage.setItem("paraRelations", e.paraRelationsWithAyats).then(function (e) {
              t(e);
            })["catch"](function (e) {
              a(e);
            });
          },
          error: function error(e, t, n) {
            a("error");
          },
          complete: function complete() {}
        }) : t(e);
      })["catch"](function (e) {
        a(e);
      });
    });
  }),
  counrtyCodeRelation = (paraRelationsPromise(), function () {
    return new Promise(function (t, a) {
      localforage.getItem("countryCodeRelation").then(function (e) {
        null === e ? $.ajax({
          url: base_path + "/JSONFiles/countryCode.json",
          dataType: "json",
          cache: !0,
          success: function success(e) {
            localforage.setItem("countryCodeRelation", e.countryCode).then(function (e) {
              t(e);
            })["catch"](function (e) {
              a(e);
            });
          },
          error: function error(e, t, n) {
            a("error");
          },
          complete: function complete() {}
        }) : t(e);
      })["catch"](function (e) {
        console.log(e), a(e);
      });
    });
  });
function juzClicked(m) {
  window.history.replaceState(null, document.title, base_path + "/juz/" + m), previousJuz = selectedJuz;
  currentScript;
  pageRelationsPromise().then(function (e) {
    for (var t, n, a = 1, o = 1, c = 1, r = 1, i = "IndoPak" == currentScript ? e.pageRelationIndoPak : e.pageRelationUthmanic, s = 0; s < i.length; s++) {
      var u = !1;
      if (i[s][2] === parseInt(m) && "IndoPak" == currentScript ? (t = i[s][selectionOfScriptNo], n = t, o = i[s][0], i[s][3], a = i[s][1], c = i[s][4], r = i[s][8], u = !0) : i[s][3] === parseInt(m) && "Uthmanic" == currentScript && (o = i[s][0], i[s][3], a = i[s][1], c = 4 == i[s][3] ? (n = t = 62, 93) : 7 == i[s][3] ? (n = t = 121, 82) : 11 == i[s][3] ? (n = t = 201, 93) : 26 == i[s][3] ? (n = t = 502, 1) : (t = i[s][selectionOfScriptNo], n = t, i[s][4]), r = i[s][8], u = !0), 1 == u) break;
    }
    juzClickedNo = m, scrollSelections.getParahJuzzNames().then(function (e) {
      "IndoPak" == currentScript ? e.ParaName : e.JuzName;
      $(".b_juz").text("Juz " + m), previousJuzPara = n;
    }), scrollAllowed = !1, document.getElementById("container").innerHTML = "", scrollSelections.goToDefinedPage(t);
    var l = isPlaying;
    l && (document.getElementById("btnPlayAudio-Btn").style.display = "none", document.getElementById("btnPauseAudio-Btn").style.display = "none", document.getElementById("progressDiv1").style.display = "inline", sound.pause()), isPlayFromOutside = !0, setTimeout(function () {
      $(".qr0").removeClass("qr0_active"), $("#" + o + "-" + c).addClass("qr0_active"), $("#" + o + "-" + c + "-T").addClass("qr0_active");
    }, 500), sharingSura = o + "-" + c, setTimeout(function () {
      localforage.setItem("surah_ruku_url_audio", padLeadingZeros(o, 3) + "-" + padLeadingZeros(a, 2)).then(function (e) {
        localforage.setItem("ayaah_ruku_url_audio", r).then(function (e) {
          localforage.setItem("ayaah_in_surah", c).then(function (e) {
            localforage.setItem("ruko_no", a).then(function (e) {
              highlightedAyaah = void 0, currentAyaah = r, isPlayFromOutside = !1, l && (document.getElementById("progressDiv1").style.display = "none", document.getElementById("btnPlayAudio-Btn").style.display = "inline", document.getElementById("btnPauseAudio-Btn").style.display = "none", ayahClick());
            });
          });
        });
      })["catch"](function (e) {
        console.log(e);
      });
    }, 1e3);
  }), localforage.setItem("selectedJuzId", m).then(function (e) {})["catch"](function (e) {}), $("#juzModal").modal("hide");
}
counrtyCodeRelation();